var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheckmarkOutline = function SvgIconCheckmarkOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#30B7FD",
    d: "M28 42.828 18 32.826 20.826 30 28 37.172 43.17 22 46 24.83z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#092B49",
    d: "M32 4a28 28 0 1 0 0 56 28 28 0 0 0 0-56m0 52a24 24 0 1 1 0-48.001A24 24 0 0 1 32 56"
  })));
};
export default SvgIconCheckmarkOutline;